import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { AssetTableRowData } from "../types";

// // // //

export const PRICE_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: "price",
    label: "Price",
    // tooltip: CatalogMetricSlugs.price_dollar,
    tooltip: "Price of the asset in USD",
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.priceDollar,
    width: 125,
    render: (item) => {
        const measure = getMeasureValue(item, "price_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        if (item.isAsset) {
            return (
                <DataGridDollarPercentChangeComboCell
                    value={measure.val}
                    pct_change_interval="30d"
                    pct_change_value={measure.chg_30d_pct}
                    decimal_places={4}
                />
            );
        }

        return <Emdash />;
    },
};

// // // //

export const PRICE_COLUMN_STABLECOIN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    ...PRICE_COLUMN,
    tooltip: "Price of the stablecoin in USD, sourced from CoinGecko",
};
